import { render, staticRenderFns } from "./EconWhereyear.vue?vue&type=template&id=3469a0a8&scoped=true&"
import script from "./EconWhereyear.vue?vue&type=script&lang=js&"
export * from "./EconWhereyear.vue?vue&type=script&lang=js&"
import style0 from "./EconWhereyear.vue?vue&type=style&index=0&id=3469a0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469a0a8",
  null
  
)

export default component.exports